/**
 * BrandLogo — vector logo of "Ok te lo vendo" marketplace.
 * Used across placeholders and empty states.
 */
export const BrandLogo = ({ className = '', label = false, size = 40, monochrome = false }) => (
    <div className={`inline-flex items-center gap-2 ${className}`}>
        <svg viewBox="0 0 64 64" width={size} height={size} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
                <linearGradient id="okl-grad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor={monochrome ? 'currentColor' : '#dc2626'} />
                    <stop offset="100%" stopColor={monochrome ? 'currentColor' : '#991b1b'} />
                </linearGradient>
            </defs>
            <rect x="2" y="2" width="60" height="60" rx="14" fill="url(#okl-grad)" />
            {/* price tag / shopping bag hybrid */}
            <path d="M20 22 L44 22 L46 30 L42 46 L22 46 L18 30 Z" fill="#fff" opacity="0.15" />
            {/* letter O + K stylized */}
            <text
                x="50%"
                y="55%"
                textAnchor="middle"
                dominantBaseline="middle"
                fontFamily="'Fredoka', 'Figtree', sans-serif"
                fontWeight="700"
                fontSize="22"
                fill="#fff"
                letterSpacing="-0.5"
            >Ok</text>
            {/* small check accent */}
            <path d="M42 42 L46 46 L52 40" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.9" />
        </svg>
        {label && (
            <span className="font-semibold text-sm">Ok te lo vendo</span>
        )}
    </div>
);

export default BrandLogo;
